import { find, get, isEmpty, toLower } from "lodash";
import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { SearchableList, LoaderWrapper } from "..";
import { useDeepEffect, useRequest } from "../../abstracts";
import { addFeeClassification, getFeeClassifications } from "../../services";
import { FieldInput } from "..";
import { errors, tranformListToDropdownValues } from "../../utils";

const FeeClassificationsDropDownComponent = ({
  data,
  onSelect,
  value,
  setData,
}) => {
  const [feeClassificationName, setFeeClassificationName] = useState();

  const [request, setRequest] = useState({
    method: getFeeClassifications,
    stopTrigger: !isEmpty(data),
  });
  const { response, loading } = useRequest(request);
  const schema = Yup.object().shape({
    feeClassificationName: Yup.string()
      .required(errors.feeClassificationName.required)
      .max(30, errors.feeClassificationName.length)
      .test(
        "feeClassificationName",
        errors.feeClassificationName.characters,
        (val) => !checkSplChar(val)
      )
      .test(
        "feeClassificationName",
        errors.feeClassificationName.alreadyExist,
        (val) => !alreadyExist(val)
      ),
  });

  const checkSplChar = (val) => {
    const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (format.test(val) === true) return true;
    else return false;
  };

  const alreadyExist = (val) => {
    const temp = data.map((item) => {
      if (toLower(item.label) === toLower(val)) return true;
      else return false;
    });
    return temp.includes(true);
  };
  const keyDown = (e) => {
    if (e.keyCode == 32) {
      e.preventDefault();
      e.target.value += " ";
    }
  };
  useDeepEffect(
    () => {
      if (!loading) {
        if (feeClassificationName) {
          const filteredValue = find(
            response,
            (item) => toLower(item.name) === toLower(feeClassificationName)
          );
          onSelect(
            get(filteredValue, "id", ""),
            get(filteredValue, "name", "")
          );
        }
        setData(tranformListToDropdownValues(response || [], "name", "id"));
      }
    },
    [loading],
    true
  );

  const onFormSubmit = (values) => {
    setFeeClassificationName(values["feeClassificationName"]);
    setRequest({
      ...request,
      method: addFeeClassification,
      stopTrigger: false,
      payload: {
        name: values["feeClassificationName"],
      },
    });
  };

  return (
    <>
      <LoaderWrapper isLoading={loading}>
        <Formik
          initialValues={{ feeClassificationName: "" }}
          validationSchema={schema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={onFormSubmit}
        >
          {({ handleChange, handleSubmit, values }) => {
            return (
              <>
                <div className="dropdside-custom-dropdown">
                  <div>
                    <SearchableList
                      label="Select an fee Classification"
                      options={data}
                      onSelect={onSelect}
                      selectedValue={value}
                    />
                  </div>
                  <div className="line-separator"></div>
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <Field
                      size="lg"
                      label="Add a Fee Classification:"
                      name={"feeClassificationName"}
                      type="text"
                      className="add-classification-field"
                      value={values["feeClassificationName"]}
                      onChange={handleChange}
                      autoComplete="off"
                      component={FieldInput}
                      placeholder={"Fee Classification"}
                      onKeyDown={keyDown}
                    />
                    <Form.Group>
                      <Button type="submit">Add</Button>
                    </Form.Group>
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>
      </LoaderWrapper>
    </>
  );
};

export default FeeClassificationsDropDownComponent;
